export default "__VITE_ASSET__B3sLnU7Y__"